exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!../static/css/Components/Footer.css"), "");

// module
exports.push([module.id, "\r\n", ""]);

// exports
